import { render, staticRenderFns } from "./ModulesTab.vue?vue&type=template&id=27b118a3&scoped=true&"
import script from "./ModulesTab.vue?vue&type=script&lang=js&"
export * from "./ModulesTab.vue?vue&type=script&lang=js&"
import style0 from "./ModulesTab.vue?vue&type=style&index=0&id=27b118a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b118a3",
  null
  
)

export default component.exports